import { Phone, MapPin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img
              src="/brand/daztec-logo.png"
              alt="DazTec logo"
              className="h-24 w-auto object-contain drop-shadow-[0_2px_12px_rgba(0,0,0,0.35)]"
            />
            <p className="mt-5 text-base text-slate-400 leading-relaxed max-w-sm">
              Friendly, local tech support for households and small businesses
              across Perth's north-western suburbs.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm uppercase tracking-[0.18em] font-semibold">
              Quick links
            </h4>
            <ul className="mt-5 space-y-3">
              <li><a href="#services" className="hover:text-white">Services</a></li>
              <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
              <li><a href="#area" className="hover:text-white">Service Area</a></li>
              <li><a href="#enquiry" className="hover:text-white">Send Enquiry</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm uppercase tracking-[0.18em] font-semibold">
              Contact
            </h4>
            <ul className="mt-5 space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 mt-0.5 text-[#D97706]" />
                <a href="tel:0409049094" data-testid="footer-phone-link" className="hover:text-white font-medium">
                  0409 049 094
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-0.5 text-[#D97706]" />
                <span>Currambine, WA 6028</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 mt-0.5 text-[#D97706]" />
                <a href="#enquiry" className="hover:text-white">Send an enquiry</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-3 text-sm text-slate-500">
          <span>© {new Date().getFullYear()} DazTec. Local. Honest. Friendly.</span>
          <span>Made with care in Currambine, WA.</span>
        </div>
      </div>
    </footer>
  );
}
